export const HOLDING = process.env.REACT_APP_HOLDING_PAGE === "true" && !/(\.preview\.emergentagent\.com|localhost|127\.0\.0\.1)$/.test(window.location.hostname);

export default function ComingSoon() {
  return (
    <main data-testid="coming-soon-page" className="relative grain min-h-screen bg-[#1E293B] text-white flex flex-col items-center justify-center px-6 text-center overflow-hidden">
      <div aria-hidden="true" className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-[#10B981]/10 blur-3xl" />
      <div aria-hidden="true" className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full bg-amber-400/10 blur-3xl" />
      <img data-testid="coming-soon-logo" src="/logo.png" alt="DhanTrove" className="relative h-16 sm:h-20 w-auto animate-[fadeIn_.8s_ease-out]" />
      <h1 data-testid="coming-soon-title" className="relative font-display font-bold text-4xl sm:text-5xl lg:text-6xl mt-10 leading-tight">
        Get ready to <span className="text-amber-400">compare.</span>
      </h1>
      <p data-testid="coming-soon-sub" className="relative mt-5 inline-flex items-center gap-2 rounded-full border border-[#10B981]/40 bg-[#10B981]/10 px-4 py-1.5 text-sm font-bold uppercase tracking-[0.2em] text-[#34D399]">
        <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse" /> Launching soon
      </p>
    </main>
  );
}
